import { useLocation } from 'react-router-dom';
import { isNativeIOS } from '../../native/nativeBridge';

/** Which design layer a Wedge session shows. `/next` and `/next/*` get 'next'; every other path, and native iOS, get 'current'. */
export type WedgeDesign = 'current' | 'next';

/** `/next/legacy` is the legacy baseline renderer, so it never carries the next design. */
export function isNextDesignPath(pathname: string): boolean {
  if (pathname === '/next/legacy' || pathname.startsWith('/next/legacy/')) return false;
  return pathname === '/next' || pathname.startsWith('/next/');
}

const here = (): string => (typeof window !== 'undefined' ? window.location.pathname : '/');

export function wedgeDesign(pathname: string = here()): WedgeDesign {
  if (isNativeIOS()) return 'current';
  return isNextDesignPath(pathname) ? 'next' : 'current';
}

export function useWedgeDesign(): WedgeDesign {
  return wedgeDesign(useLocation().pathname);
}

const BASE_KEY = 'wedge_design_base';

/** Remember the design across a full-page OAuth round trip (the redirect URI stays `/integrations/callback`). */
export function rememberDesignBase(): void {
  try { sessionStorage.setItem(BASE_KEY, wedgeDesign() === 'next' ? '/next' : ''); } catch { /* storage blocked */ }
}

/** Where an OAuth return lands: `/next` when the flow started on /next, else `/`. Read once. */
export function consumeDesignHome(): string {
  try {
    const base = sessionStorage.getItem(BASE_KEY);
    sessionStorage.removeItem(BASE_KEY);
    return base === '/next' ? '/next' : '/';
  } catch { return '/'; }
}
